import { ILineData } from "@leafer-ui/interface"

import { UIData } from "./UIData"


export class LineData extends UIData implements ILineData {

}
